import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * Placeholder for old room chat routes
 * Redirects to new room detail structure
 */
const RoomChatPlaceholder = ({ directAccess = false }) => {
  const { roomId } = useParams();
  const navigate = useNavigate();

  // Redirect to new room detail structure
  useEffect(() => {
    if (roomId) {
navigate(`/labs/${roomId}`, { replace: true });
    } else {
      navigate("/labs", { replace: true });
    }
  }, [roomId, navigate]);

  return null;
};

export default RoomChatPlaceholder;
